(function () {
  'use strict';

  if (window.PrewornCardCartLoaded) return;
  window.PrewornCardCartLoaded = true;

  var productCache = {};
  var cartState = null;
  var cartPromise = null;
  var toastTimer = null;
  var syncQueued = false;

  function routesPath(name, fallback) {
    return window.routes && window.routes[name] ? window.routes[name] : fallback;
  }

  function productHandle(button) {
    var handle = String(button.getAttribute('data-product-handle') || '').trim();
    if (handle) return handle;

    var url = String(button.getAttribute('data-product-url') || '');
    var match = url.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function fetchProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = window.fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('This piece is no longer available.');
        return response.json();
      }).catch(function (error) {
        delete productCache[handle];
        throw error;
      });
    }

    return productCache[handle];
  }

  function availableVariant(product) {
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available !== false) return variants[i];
    }
    return null;
  }

  function itemHandle(item) {
    if (item && item.handle) return String(item.handle);
    var url = String(item && item.url || '');
    var match = url.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function cartItemsForHandle(handle) {
    if (!cartState || !Array.isArray(cartState.items)) return [];
    return cartState.items.filter(function (item) {
      return itemHandle(item) === handle;
    });
  }

  function updateHeaderCount(count) {
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;

    var badge = link.querySelector('.pw-header-cart-count');
    if (count > 0 && !badge) {
      badge = document.createElement('span');
      badge.className = 'pw-header-cart-count';
      badge.setAttribute('aria-hidden', 'true');
      link.appendChild(badge);
    }

    if (badge) {
      badge.textContent = count < 100 ? String(count) : '99+';
      badge.hidden = count < 1;
    }

    link.setAttribute('aria-label', 'Bag' + (count ? ', ' + count + (count === 1 ? ' item' : ' items') : ''));
  }

  function setButtonState(button, state) {
    var added = state === 'added';
    var loading = state === 'loading';

    button.classList.toggle('is-loading', loading);
    button.classList.toggle('is-added', added);
    button.disabled = loading;
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
    button.setAttribute('aria-pressed', added ? 'true' : 'false');

    if (loading) {
      button.setAttribute('aria-label', added ? 'Removing from basket' : 'Updating basket');
      button.setAttribute('title', added ? 'Removing from basket' : 'Updating basket');
    } else if (added) {
      button.setAttribute('aria-label', 'Remove from basket');
      button.setAttribute('title', 'Remove from basket');
    } else {
      button.setAttribute('aria-label', 'Add to basket');
      button.setAttribute('title', 'Add to basket');
    }
  }

  function syncButtons() {
    var handles = {};
    if (cartState && Array.isArray(cartState.items)) {
      cartState.items.forEach(function (item) {
        var handle = itemHandle(item);
        if (handle) handles[handle] = true;
      });
    }

    var buttons = document.querySelectorAll('[data-pw-add-cart]');
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].classList.contains('is-loading')) continue;
      setButtonState(buttons[i], handles[productHandle(buttons[i])] ? 'added' : 'idle');
    }
  }

  function applyCart(cart) {
    cartState = cart || { items: [], item_count: 0 };
    updateHeaderCount(Number(cartState.item_count) || 0);
    syncButtons();
    return cartState;
  }

  function fetchCart(force) {
    if (!force && cartState) return Promise.resolve(cartState);
    if (cartPromise) return cartPromise;

    if (window.PrewornCart && typeof window.PrewornCart.refresh === 'function') {
      cartPromise = window.PrewornCart.refresh(false).then(applyCart).finally(function () {
        cartPromise = null;
      });
      return cartPromise;
    }

    cartPromise = window.fetch(routesPath('cart_url', '/cart') + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Your basket could not be loaded.');
      return response.json();
    }).then(applyCart).finally(function () {
      cartPromise = null;
    });
    return cartPromise;
  }

  function postCart(url, body) {
    return window.fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Your basket could not be updated.');
        }
        return data;
      });
    });
  }

  function addVariant(variantId) {
    return postCart(routesPath('cart_add_url', '/cart/add.js'), {
      id: Number(variantId),
      quantity: 1
    }).then(function () {
      return fetchCart(true);
    }).then(function (cart) {
      if (window.PrewornCart && typeof window.PrewornCart.open === 'function') {
        window.PrewornCart.open();
      }
      return cart;
    });
  }

  function removeHandle(handle) {
    var matches = cartItemsForHandle(handle);
    var updates = {};
    for (var i = 0; i < matches.length; i++) {
      updates[matches[i].key || matches[i].id] = 0;
    }

    if (!Object.keys(updates).length) return Promise.resolve(cartState);

    if (window.PrewornCart && typeof window.PrewornCart.update === 'function') {
      return window.PrewornCart.update(updates, false).then(applyCart);
    }

    return postCart(routesPath('cart_update_url', '/cart/update.js'), {
      updates: updates
    }).then(applyCart);
  }

  function ensureToast() {
    var toast = document.querySelector('[data-pw-cart-toast]');
    if (toast) return toast;

    toast = document.createElement('div');
    toast.className = 'pw-card-cart-toast';
    toast.setAttribute('data-pw-cart-toast', '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.hidden = true;
    toast.innerHTML = '<span data-pw-cart-toast-message></span><a href="' +
      routesPath('cart_url', '/cart') + '">VIEW BAG <span aria-hidden="true">↗</span></a>';
    document.body.appendChild(toast);
    return toast;
  }

  function showToast(message, isError) {
    var toast = ensureToast();
    var text = toast.querySelector('[data-pw-cart-toast-message]');
    if (text) text.textContent = message;
    toast.classList.toggle('is-error', !!isError);
    toast.hidden = false;

    if (toastTimer) window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      toast.hidden = true;
    }, isError ? 5500 : 3500);
  }

  function toggleCardProduct(button) {
    var handle = productHandle(button);
    if (!handle || button.disabled || button.classList.contains('is-loading')) return;

    var wasAdded = button.classList.contains('is-added');
    setButtonState(button, 'loading');

    fetchCart(true).then(function () {
      var inCart = cartItemsForHandle(handle).length > 0;
      if (inCart) {
        return removeHandle(handle).then(function (cart) {
          showToast('Removed from your bag', false);
          return cart;
        });
      }

      return fetchProduct(handle).then(function (product) {
        var variant = availableVariant(product);
        if (!variant) throw new Error('Sorry, this one-off piece has just sold.');

        var duplicate = cartState && cartState.items && cartState.items.some(function (item) {
          return Number(item.variant_id || item.id) === Number(variant.id);
        });
        if (duplicate) return cartState;
        return addVariant(variant.id);
      });
    }).then(function (cart) {
      applyCart(cart);
      var nowAdded = cartItemsForHandle(handle).length > 0;
      setButtonState(button, nowAdded ? 'added' : 'idle');
      if (typeof window.CustomEvent === 'function') {
        window.dispatchEvent(new CustomEvent('preworn:cart-toggle', {
          detail: { handle: handle, added: nowAdded, cart: cart }
        }));
      }
    }).catch(function (error) {
      setButtonState(button, wasAdded ? 'added' : 'idle');
      showToast(error && error.message ? error.message : 'Your basket could not be updated.', true);
    });
  }

  function queueButtonSync() {
    if (syncQueued) return;
    syncQueued = true;
    window.requestAnimationFrame(function () {
      syncQueued = false;
      syncButtons();
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-pw-add-cart]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    toggleCardProduct(button);
  });

  window.addEventListener('preworn:cart-change', function (event) {
    if (event.detail && event.detail.cart) applyCart(event.detail.cart);
    else fetchCart(true).catch(function () {});
  });

  window.addEventListener('pageshow', function () {
    fetchCart(true).catch(function () {});
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) fetchCart(true).catch(function () {});
  });

  if (typeof window.MutationObserver === 'function') {
    new MutationObserver(queueButtonSync).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  fetchCart(true).catch(function () {
    syncButtons();
  });
})();
